import type { CustomerNotificationIndicatorResponse } from '@kizen/api/customer-notifications';
import type { SemanticColorName } from '@kizen/kds/Colors';

type Status = Exclude<CustomerNotificationIndicatorResponse['status'], 'none'>;

type StatusColor = `var(--color-${Extract<
  SemanticColorName,
  | 'feedback-toast-error'
  | 'feedback-toast-information'
  | 'feedback-toast-success'
  | 'feedback-toast-warning'
>})`;

export type StatusColorClass = `bg-[${StatusColor}]`;

export const INDICATOR_COLORS = {
  in_progress: 'var(--color-feedback-toast-success)',
  error: 'var(--color-feedback-toast-error)',
  warning: 'var(--color-feedback-toast-warning)',
  info: 'var(--color-feedback-toast-information)',
} as const satisfies Record<Status, StatusColor>;
